// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountFutureRequirementsArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  Scalars,
  OpenapiAccountFutureRequirementsDisabledReasonEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAccountRequirementsAlternativeArkFragment} from './stripeAccountRequirementsAlternativeArkFragment';
import {stripeAccountRequirementsErrorArkFragment} from './stripeAccountRequirementsErrorArkFragment';

import type {StripeAccountRequirementsAlternativeArkFragmentData} from './stripeAccountRequirementsAlternativeArkFragment';
import type {StripeAccountRequirementsErrorArkFragmentData} from './stripeAccountRequirementsErrorArkFragment';

const doc = gql`
  fragment StripeAccountFutureRequirementsArkFragment on OpenapiAccountFutureRequirements {
    alternatives {
      ...StripeAccountRequirementsAlternativeArkFragment
    }
    current_deadline
    currently_due
    disabled_reason
    errors {
      ...StripeAccountRequirementsErrorArkFragment
    }
    eventually_due
    past_due
    pending_verification
    previously_due
    requirements
  }

  ${stripeAccountRequirementsAlternativeArkFragment}
  ${stripeAccountRequirementsErrorArkFragment}
`;

export const stripeAccountFutureRequirementsArkFragment: StripeAccountFutureRequirementsArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountFutureRequirementsArkFragmentData = {
  readonly __typename: 'OpenapiAccountFutureRequirements';
  readonly current_deadline: number | null;
  readonly currently_due: ReadonlyArray<string> | null;
  readonly disabled_reason: OpenapiAccountFutureRequirementsDisabledReasonEnum | null;
  readonly eventually_due: ReadonlyArray<string> | null;
  readonly past_due: ReadonlyArray<string> | null;
  readonly pending_verification: ReadonlyArray<string> | null;
  readonly previously_due: ReadonlyArray<string> | null;
  readonly requirements: Scalars['JSONObject'] | null;
  readonly alternatives: ReadonlyArray<
    GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirementsAlternative'},
      [StripeAccountRequirementsAlternativeArkFragmentData]
    >
  > | null;
  readonly errors: ReadonlyArray<
    GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirementsError'},
      [StripeAccountRequirementsErrorArkFragmentData]
    >
  > | null;
};

export type StripeAccountFutureRequirementsArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountFutureRequirementsArkFragmentPermissions = {
  ...stripeAccountRequirementsAlternativeArkFragment.permissions,
  ...stripeAccountRequirementsErrorArkFragment.permissions,
} as const;

doc.permissions = stripeAccountFutureRequirementsArkFragmentPermissions;

export type StripeAccountFutureRequirementsArkFragmentPermissions =
  V1PermissionToken<
    typeof stripeAccountFutureRequirementsArkFragmentPermissions
  >;

export type StripeAccountFutureRequirementsArkFragmentDocument =
  GraphQlDocument<
    StripeAccountFutureRequirementsArkFragmentData,
    StripeAccountFutureRequirementsArkFragmentVariables,
    StripeAccountFutureRequirementsArkFragmentPermissions
  >;
